import React, { useState } from 'react';
import {
  ActivityIndicator,
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { useAuth } from '../contexts/AuthContext';
import { notify } from '../ui/dialogs';
import { colors, spacing, radius, typography, shadow } from '../config/theme';
import { StickerBackdrop, Wordmark } from './brand';

export default function LoginScreen({ navigation }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async () => {
    if (!email || !password) {
      notify('Ошибка', 'Заполните все поля');
      return;
    }
    setLoading(true);
    try {
      await login(email, password);
    } catch (error) {
      notify('Ошибка входа', error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LinearGradient colors={[colors.gradientStart, colors.gradientEnd]} style={styles.container}>
      <StickerBackdrop seed="login" opacity={0.2} />
      <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : 'height'} style={styles.keyboardView}>
        <View style={styles.column}>
        <View style={styles.header}>
          <Wordmark full height={92} color={colors.textPrimary} />
          <Text style={styles.environment}>◆ TEST ◆</Text>
        </View>
        <Text style={styles.title}>Вход</Text>
        <Text style={styles.subtitle}>Войдите как тестовый сотрудник</Text>
        <View style={styles.form}>
          <TextInput
            style={styles.input}
            placeholder="Email"
            placeholderTextColor={colors.textMuted}
            keyboardType="email-address"
            autoCapitalize="none"
            autoCorrect={false}
            value={email}
            onChangeText={setEmail}
          />
          <TextInput
            style={styles.input}
            placeholder="Пароль"
            placeholderTextColor={colors.textMuted}
            secureTextEntry
            value={password}
            onChangeText={setPassword}
          />
          <TouchableOpacity style={styles.button} onPress={handleLogin} disabled={loading}>
            {loading ? <ActivityIndicator color={colors.onPrimary} /> : <Text style={styles.buttonText}>Войти</Text>}
          </TouchableOpacity>
          <TouchableOpacity style={styles.link} onPress={() => navigation.navigate('InviteAccept')}>
            <Text style={styles.linkText}>Есть приглашение? <Text style={styles.linkAccent}>Активировать</Text></Text>
          </TouchableOpacity>
        </View>
        </View>
      </KeyboardAvoidingView>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, overflow: 'hidden' },
  keyboardView: { flex: 1, justifyContent: 'center', paddingHorizontal: spacing.xl },
  column: { width: '100%', maxWidth: 400, alignSelf: 'center' },
  header: { alignItems: 'center', marginBottom: spacing.xxl, gap: spacing.sm },
  environment: { ...typography.caption, color: colors.primary, fontWeight: '800', letterSpacing: 3 },
  title: { ...typography.h1, color: colors.textPrimary, marginBottom: spacing.xs },
  subtitle: { ...typography.body, color: colors.textSecondary, marginBottom: spacing.xl },
  form: { gap: spacing.md },
  input: {
    backgroundColor: colors.inputBackground,
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: radius.md,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.md,
    color: colors.textPrimary,
    ...typography.body,
  },
  button: {
    backgroundColor: colors.primary,
    paddingVertical: spacing.md + 2,
    borderRadius: radius.lg,
    alignItems: 'center',
    marginTop: spacing.md,
    ...shadow.button,
  },
  buttonText: { ...typography.button, color: colors.onPrimary },
  link: { alignItems: 'center', marginTop: spacing.md },
  linkText: { ...typography.body, color: colors.textMuted },
  linkAccent: { color: colors.primary, fontWeight: '700' },
});
